import { notification } from 'antd'

import AdditionAPI from '@apis/branch/addition'

import ConfirmModal from '@components/molecules/ConfirmModal'

type Props = {
  hqId: number
  branchId: number
  additionId?: number
  visible: boolean
  onClose: () => void
  onDone: () => void
}

export default function AdditionDeleteModal({
  hqId,
  branchId,
  additionId,
  visible,
  onClose,
  onDone,
}: Props): JSX.Element {
  const onConfirm = async () => {
    if (!additionId) return
    await AdditionAPI.deleteAddition({ hqId, branchId, additionId })
    notification.success({ message: '삭제 되었습니다.' })
  }

  return (
    <ConfirmModal
      title="부가서비스 삭제"
      description="부가서비스를 삭제하면 계약 및 청구 관련 기능이 정상작동되지 않을 수 있습니다."
      okText="삭제"
      onConfirm={onConfirm}
      visible={visible}
      onClose={onClose}
      onDone={onDone}
    />
  )
}
